import { render, staticRenderFns } from "./energy-compare.vue?vue&type=template&id=6dde05a1&scoped=true"
import script from "./energy-compare.vue?vue&type=script&lang=js"
export * from "./energy-compare.vue?vue&type=script&lang=js"
import style0 from "./energy-compare.vue?vue&type=style&index=0&id=6dde05a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dde05a1",
  null
  
)

export default component.exports